import { render, staticRenderFns } from "./AddressUnitCard.vue?vue&type=template&id=5623d382&scoped=true"
import script from "./AddressUnitCard.vue?vue&type=script&lang=js"
export * from "./AddressUnitCard.vue?vue&type=script&lang=js"
import style0 from "./AddressUnitCard.vue?vue&type=style&index=0&id=5623d382&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623d382",
  null
  
)

export default component.exports